import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { useState, useCallback, useEffect } from "react";
import CommonSelect from "components/CommonSelect/select";
import { provincesSync } from "rest/sync/requestsSync";
import { cantonsByProvince } from "rest/requests";
import { parroquiasByCanton } from "rest/requests";
import { storesByProvinceId } from "rest/requests";
import { storesByCantonId } from "rest/requests";
import { storesByParroquias } from "rest/requests";
import CommonSelectWithoutNoneOption from "components/CommonSelect/selectWithoutNoneOption";

export default function CatastroAlmacenesFilters({ setStores, selectedIdProvince }) {
  const [selectedProvince, setSelectedProvince] = useState(selectedIdProvince);
  const [selectedCanton, setSelectedCanton] = useState(null);
  const [selectedParroquia, setSelectedParroquia] = useState(null);

  let provincesList = provincesSync();
  const [cantonList, setCantonList] = useState([]);
  const [parroquiaList, setParroquiaList] = useState([]);

  const getCantonByProvince = useCallback(async () => {
    console.log("Selected Province: ", selectedProvince);
    if (selectedProvince) {
      setCantonList(await cantonsByProvince(selectedProvince));
      setStores(await storesByProvinceId(selectedProvince));
    }
  }, [selectedProvince]);

  useEffect(() => {
    getCantonByProvince();
  }, [selectedProvince]);

  const getParroquiaByCanton = useCallback(async () => {
    console.log("Selected Canton: ", selectedCanton);
    if (selectedCanton) {
      setParroquiaList(await parroquiasByCanton(selectedCanton));
      setStores(await storesByCantonId(selectedCanton));
    }
  }, [selectedCanton]);

  useEffect(() => {
    getParroquiaByCanton();
  }, [selectedCanton]);

  const getData = useCallback(async () => {
    console.log("Selected Parroquia: ", selectedParroquia);
    if (selectedParroquia) {
      setStores(await storesByParroquias(selectedParroquia));
    }
  }, [selectedParroquia]);

  useEffect(() => {
    getData();
  }, [selectedParroquia]);

  return (
    <div>
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container>
          <Grid item padding={1}>
            <CommonSelectWithoutNoneOption
              label="Provincia"
              defaultValue={selectedIdProvince}
              data={provincesList.map((e) => {
                return { id: e.idProvince, name: e.name };
              })}
              onChange={(selectedValue) => setSelectedProvince(selectedValue)}
            ></CommonSelectWithoutNoneOption>
          </Grid>
          <Grid item padding={1}>
            <CommonSelect
              label="Cantón"
              data={cantonList.map((e) => {
                return { id: e.idCanton, name: e.name };
              })}
              onChange={(selectedValue) => setSelectedCanton(selectedValue)}
            ></CommonSelect>
          </Grid>
          <Grid item padding={1}>
            <CommonSelect
              label="Parroquia"
              data={parroquiaList.map((e) => {
                return { id: e.idParish, name: e.name };
              })}
              onChange={(selectedValue) => setSelectedParroquia(selectedValue)}
            ></CommonSelect>
          </Grid>
        </Grid>
      </MDBox>
      <br></br>
    </div>
  );
}

CatastroAlmacenesFilters.defaultProps = {
  setStores: null,
  selectedIdProvince: null,
};

CatastroAlmacenesFilters.propTypes = {
  setStores: PropTypes.func,
  selectedIdProvince: PropTypes.number,
};
